import { render, staticRenderFns } from "./ReviewReproduction.vue?vue&type=template&id=f8bb5ea6&"
import script from "./ReviewReproduction.vue?vue&type=script&lang=js&"
export * from "./ReviewReproduction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports